import { useSelfContext } from '@/context';
import { useWeekChangeManagement } from '@/hooks';
import { getSelfTypeByVaraiant } from '@/context';
import { PageContainer, WeekChanger } from '@/components';
import ReserveReport from './ReserveReport';
import { useTranslation } from 'react-i18next';
import { ReserveHttp } from '@/services';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

export interface ReserveReportPageProps {
  variant: ComponentVariant;
}

export function ReserveReportPage({ variant }: ReserveReportPageProps) {
  const { showingDate, changeWeek } = useSelfContext();
  const [finalData, setFinalData] = useState<any>(null);

  const {
    currentDot,
    onPressRight,
    onPressLeft,
    weekDates,
    onPressDot,
  } = useWeekChangeManagement((selectedDate) => {
    changeWeek(selectedDate);
  });

  const [t] = useTranslation(['common', 'reserve']);

  const { data: reservesPayload, error: reservesError, isLoading: reservesLoading, refetch: refetchReserves } = useQuery({
    queryKey: ['/rest/reserves', showingDate],
    queryFn: async () => (await ReserveHttp.fetchReserveReport(showingDate, getSelfTypeByVaraiant(variant))).payload
  });

  const { data: dailySalesPayload, isLoading: dailySalesLoading } = useQuery({
    queryKey: ['/rest/reserve/reserve-daily-sale'],
    queryFn: async () => (await ReserveHttp.fetchCurrentDailySaleReserves()).data.payload
  });

  useEffect(() => {
    if (!reservesLoading && !dailySalesLoading && reservesPayload && dailySalesPayload) {
      const updatedWeekDays = reservesPayload.weekDays.map(day => {
        const matchingDailySales = Array.isArray(dailySalesPayload) 
          ? dailySalesPayload.filter(sale => sale.programDate.split(' ')[0] === day.date)
          : [];          

        if (matchingDailySales.length > 0) {
          return {
            ...day,
            mealTypes: day.mealTypes || [],
            dailySales: matchingDailySales
          };
        }
        return day;
      });

      const finalResult = {
        ...reservesPayload,
        weekDays: updatedWeekDays
      };

      setFinalData(finalResult);
    }
  }, [reservesLoading, dailySalesLoading, reservesPayload, dailySalesPayload]);
  

  return (
    <PageContainer
      noPadding
      displayFlex
      title={t('reserve:labels.reserve-status')}
    >
      <ReserveReport
        variant={variant}
        loading={reservesLoading || dailySalesLoading}
        error={reservesError?.message}
        onRetry={refetchReserves}
        reportList={finalData?.weekDays || reservesPayload?.weekDays}
        mealTypeList={finalData?.mealTypes || reservesPayload?.mealTypes}
      />
      <WeekChanger
        currentDot={currentDot}
        weekDates={weekDates}
        onPressLeft={onPressLeft}
        onPressRight={onPressRight}
        onPressDot={onPressDot}
      />
    </PageContainer>
  );
}

export default ReserveReportPage;
